export default __webpack_public_path__ + "static/media/Section4-main.499aa576.svg";